 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-06a15036":"a34242a6","chunk-08b5b1ae":"f07a4322","chunk-09d6dff3":"aed9e614","chunk-0c2ba875":"38299b24","chunk-109e4a0e":"5e2206c2","chunk-125d9736":"d76cd479","chunk-13118c86":"1d2c297e","chunk-1881c65f":"96cd520a","chunk-1a324f0c":"1d7cbc5c","chunk-1b247cbd":"d5cf8802","chunk-1bc8f52c":"80f1a741","chunk-1dbe5eaf":"2d4d1ecb","chunk-20452b85":"29b7fa57","chunk-208c2446":"1852e9d5","chunk-2349b137":"7ffaafe3","chunk-28466fc8":"26302b8a","chunk-2be04912":"7db1ed87","chunk-2d0b345c":"0e0c2e87","chunk-2d0bce05":"815e7c4d","chunk-2d0c77ad":"abcb3cf8","chunk-2d0c8f6d":"b7c31569","chunk-2d0c91d2":"427a14dc","chunk-2d0cb6e8":"43465176","chunk-2d0cbb33":"447a896e","chunk-2d0d0818":"19227fff","chunk-2d0da2ea":"a9a1ade9","chunk-2d0da6a8":"e80af358","chunk-2d0dace4":"0220677a","chunk-2d0e95df":"267f93a0","chunk-2d210c28":"0432a497","chunk-2d212fd8":"2ec362d0","chunk-2d217361":"09edee1d","chunk-2d2253ae":"f7688768","chunk-303254b2":"bc5a01f6","chunk-347ebcac":"94236dae","chunk-354b2aa8":"0164b08f","chunk-35a579a2":"69ef3345","chunk-38867a61":"9336dec4","chunk-3b7d8115":"96e97139","chunk-3d675996":"03244ca9","chunk-3dbd8674":"b601dd06","chunk-3e7f77bf":"8e144176","chunk-41ce4c8b":"b086f0d2","chunk-41ef6366":"306f4ac3","chunk-44a3da96":"ffd5fae4","chunk-44eaecce":"e291ede6","chunk-49117393":"5c700b1b","chunk-4b380372":"13c02c5e","chunk-4d17f324":"b1d9e487","chunk-4e2b9ee0":"62bf4644","chunk-4eb6a338":"083bef45","chunk-500f1185":"7a4f1a9d","chunk-51bf7232":"f0308f30","chunk-52c84d8c":"8dde556b","chunk-545326c0":"6e1c3b2f","chunk-56cc7a73":"801ff134","chunk-56dec1a4":"2a3d5d89","chunk-5a84305a":"eaa9941e","chunk-5af9d9b0":"eefc2c27","chunk-5ddea5ea":"7460e7c2","chunk-5fd9ef88":"9182a69c","chunk-609a6aeb":"bd01c10f","chunk-609e28f6":"cbb24e00","chunk-636f4260":"02f640f9","chunk-646bac48":"b2798c02","chunk-66173c80":"78623a25","chunk-6700755d":"e8c55b29","chunk-67147130":"dc755e17","chunk-67811b1b":"d917e635","chunk-67db813b":"44ac1758","chunk-6993bb39":"ed32ec62","chunk-6ac44d3d":"b26e6a32","chunk-6b3b5ac7":"3f3b5dbf","chunk-6b568ccc":"9871565d","chunk-28e70a5a":"8c9c8e22","chunk-48bc6b4d":"2b81304a","chunk-49ff5f25":"92c9d3b7","chunk-6cd8d239":"6b4f7c79","chunk-4dc0318a":"13fab620","chunk-c154174a":"019eaeae","chunk-6d7092e8":"e118cecc","chunk-6e6dcf96":"a81fd59f","chunk-6f384fdc":"945caa74","chunk-6f5955ca":"8ac49e2e","chunk-00357acc":"0cf184f3","chunk-17d2ea76":"be1d87bb","chunk-31e3aaf3":"52152ce8","chunk-3635a07f":"275fb0a4","chunk-4b330e93":"c7762335","chunk-4e2546e6":"10245390","chunk-540eb546":"290b4e27","chunk-59d91b22":"3d81b326","chunk-844aa964":"23bcb2cd","chunk-8f099ab8":"b74eb872","chunk-9fe4383e":"b3ed3956","chunk-b92141c0":"bb098c0b","chunk-dd2b1d46":"b4110389","chunk-6f60227b":"9132a398","chunk-70e35ebc":"3c1482b9","chunk-711ff2f0":"557c36b8","chunk-71bd526a":"c72bd1d7","chunk-72294d4c":"c84be084","chunk-73e9d5f2":"abf454c4","chunk-744c292d":"fadf926a","chunk-7459c046":"15b887e4","chunk-75203fab":"b56dbf5e","chunk-75b8b6cb":"63833b89","chunk-77f6f964":"815568b9","chunk-78ab511f":"5cc52584","chunk-7cdb600e":"a459ee6d","chunk-7e16cd9d":"b3251482","chunk-7ed8b0ce":"e9b02904","chunk-7f66c91b":"91d30fb3","chunk-7f706172":"2d08ee28","chunk-7fb62e64":"93aa76c2","chunk-8039543e":"65ccc3e7","chunk-8c0aeddc":"185bc046","chunk-2b02de32":"f5ffdd05","chunk-7f881edd":"89e3ffe6","chunk-9827d096":"9ed26c62","chunk-982b6af2":"9183adad","chunk-99bcc778":"cf1cee87","chunk-9ac5abb0":"346bf5a1","chunk-9eba3760":"7e251faa","chunk-a39ff88a":"2deda24e","chunk-a8544154":"a8461d07","chunk-ac7c3ac8":"141c5df5","chunk-adc2bb66":"3ac5f294","chunk-b0a53dac":"d794b749","chunk-b81bcb8a":"648f9d12","chunk-ba7d386c":"7e2f2b3e","chunk-bb9055bc":"e6f7051e","chunk-bc926f2a":"d10a6e48","chunk-c5f01380":"14e2952d","chunk-c6b29aa4":"98a2f2c5","chunk-cf78b932":"690f5b18","chunk-d2175d8a":"b76d1a2f","chunk-e1a6d904":"432221d9","chunk-ed77b080":"79575152","chunk-faf9c3f6":"2cb37193","fail":"7778d049","lang-en-US":"ac8f3aa2","lang-en-US-setting":"fcce41ed","lang-vi":"23307221","lang-vi-setting":"8f8c24a9","user":"ed42d875"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08b5b1ae":1,"chunk-1dbe5eaf":1,"chunk-354b2aa8":1,"chunk-56cc7a73":1,"chunk-56dec1a4":1,"chunk-609a6aeb":1,"chunk-609e28f6":1,"chunk-636f4260":1,"chunk-6700755d":1,"chunk-6b568ccc":1,"chunk-48bc6b4d":1,"chunk-6cd8d239":1,"chunk-4dc0318a":1,"chunk-c154174a":1,"chunk-744c292d":1,"chunk-7459c046":1,"chunk-7ed8b0ce":1,"chunk-7f66c91b":1,"chunk-7f706172":1,"chunk-8039543e":1,"chunk-a39ff88a":1,"chunk-d2175d8a":1,"chunk-faf9c3f6":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-06a15036":"31d6cfe0","chunk-08b5b1ae":"4f477acb","chunk-09d6dff3":"31d6cfe0","chunk-0c2ba875":"31d6cfe0","chunk-109e4a0e":"31d6cfe0","chunk-125d9736":"31d6cfe0","chunk-13118c86":"31d6cfe0","chunk-1881c65f":"31d6cfe0","chunk-1a324f0c":"31d6cfe0","chunk-1b247cbd":"31d6cfe0","chunk-1bc8f52c":"31d6cfe0","chunk-1dbe5eaf":"41bd5bb8","chunk-20452b85":"31d6cfe0","chunk-208c2446":"31d6cfe0","chunk-2349b137":"31d6cfe0","chunk-28466fc8":"31d6cfe0","chunk-2be04912":"31d6cfe0","chunk-2d0b345c":"31d6cfe0","chunk-2d0bce05":"31d6cfe0","chunk-2d0c77ad":"31d6cfe0","chunk-2d0c8f6d":"31d6cfe0","chunk-2d0c91d2":"31d6cfe0","chunk-2d0cb6e8":"31d6cfe0","chunk-2d0cbb33":"31d6cfe0","chunk-2d0d0818":"31d6cfe0","chunk-2d0da2ea":"31d6cfe0","chunk-2d0da6a8":"31d6cfe0","chunk-2d0dace4":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","chunk-2d210c28":"31d6cfe0","chunk-2d212fd8":"31d6cfe0","chunk-2d217361":"31d6cfe0","chunk-2d2253ae":"31d6cfe0","chunk-303254b2":"31d6cfe0","chunk-347ebcac":"31d6cfe0","chunk-354b2aa8":"1b938cc5","chunk-35a579a2":"31d6cfe0","chunk-38867a61":"31d6cfe0","chunk-3b7d8115":"31d6cfe0","chunk-3d675996":"31d6cfe0","chunk-3dbd8674":"31d6cfe0","chunk-3e7f77bf":"31d6cfe0","chunk-41ce4c8b":"31d6cfe0","chunk-41ef6366":"31d6cfe0","chunk-44a3da96":"31d6cfe0","chunk-44eaecce":"31d6cfe0","chunk-49117393":"31d6cfe0","chunk-4b380372":"31d6cfe0","chunk-4d17f324":"31d6cfe0","chunk-4e2b9ee0":"31d6cfe0","chunk-4eb6a338":"31d6cfe0","chunk-500f1185":"31d6cfe0","chunk-51bf7232":"31d6cfe0","chunk-52c84d8c":"31d6cfe0","chunk-545326c0":"31d6cfe0","chunk-56cc7a73":"817f0b53","chunk-56dec1a4":"8a41c503","chunk-5a84305a":"31d6cfe0","chunk-5af9d9b0":"31d6cfe0","chunk-5ddea5ea":"31d6cfe0","chunk-5fd9ef88":"31d6cfe0","chunk-609a6aeb":"2ddf9451","chunk-609e28f6":"4e3f5168","chunk-636f4260":"6a778d04","chunk-646bac48":"31d6cfe0","chunk-66173c80":"31d6cfe0","chunk-6700755d":"826d82f5","chunk-67147130":"31d6cfe0","chunk-67811b1b":"31d6cfe0","chunk-67db813b":"31d6cfe0","chunk-6993bb39":"31d6cfe0","chunk-6ac44d3d":"31d6cfe0","chunk-6b3b5ac7":"31d6cfe0","chunk-6b568ccc":"73a11033","chunk-28e70a5a":"31d6cfe0","chunk-48bc6b4d":"29b93a9c","chunk-49ff5f25":"31d6cfe0","chunk-6cd8d239":"8f543a3f","chunk-4dc0318a":"4aa6b438","chunk-c154174a":"e3a93821","chunk-6d7092e8":"31d6cfe0","chunk-6e6dcf96":"31d6cfe0","chunk-6f384fdc":"31d6cfe0","chunk-6f5955ca":"31d6cfe0","chunk-00357acc":"31d6cfe0","chunk-17d2ea76":"31d6cfe0","chunk-31e3aaf3":"31d6cfe0","chunk-3635a07f":"31d6cfe0","chunk-4b330e93":"31d6cfe0","chunk-4e2546e6":"31d6cfe0","chunk-540eb546":"31d6cfe0","chunk-59d91b22":"31d6cfe0","chunk-844aa964":"31d6cfe0","chunk-8f099ab8":"31d6cfe0","chunk-9fe4383e":"31d6cfe0","chunk-b92141c0":"31d6cfe0","chunk-dd2b1d46":"31d6cfe0","chunk-6f60227b":"31d6cfe0","chunk-70e35ebc":"31d6cfe0","chunk-711ff2f0":"31d6cfe0","chunk-71bd526a":"31d6cfe0","chunk-72294d4c":"31d6cfe0","chunk-73e9d5f2":"31d6cfe0","chunk-744c292d":"3aac4123","chunk-7459c046":"3426b597","chunk-75203fab":"31d6cfe0","chunk-75b8b6cb":"31d6cfe0","chunk-77f6f964":"31d6cfe0","chunk-78ab511f":"31d6cfe0","chunk-7cdb600e":"31d6cfe0","chunk-7e16cd9d":"31d6cfe0","chunk-7ed8b0ce":"8a41c503","chunk-7f66c91b":"66183a72","chunk-7f706172":"11711f41","chunk-7fb62e64":"31d6cfe0","chunk-8039543e":"a60f24a6","chunk-8c0aeddc":"31d6cfe0","chunk-2b02de32":"31d6cfe0","chunk-7f881edd":"31d6cfe0","chunk-9827d096":"31d6cfe0","chunk-982b6af2":"31d6cfe0","chunk-99bcc778":"31d6cfe0","chunk-9ac5abb0":"31d6cfe0","chunk-9eba3760":"31d6cfe0","chunk-a39ff88a":"f336c531","chunk-a8544154":"31d6cfe0","chunk-ac7c3ac8":"31d6cfe0","chunk-adc2bb66":"31d6cfe0","chunk-b0a53dac":"31d6cfe0","chunk-b81bcb8a":"31d6cfe0","chunk-ba7d386c":"31d6cfe0","chunk-bb9055bc":"31d6cfe0","chunk-bc926f2a":"31d6cfe0","chunk-c5f01380":"31d6cfe0","chunk-c6b29aa4":"31d6cfe0","chunk-cf78b932":"31d6cfe0","chunk-d2175d8a":"9a85fade","chunk-e1a6d904":"31d6cfe0","chunk-ed77b080":"31d6cfe0","chunk-faf9c3f6":"36527024","fail":"31d6cfe0","lang-en-US":"31d6cfe0","lang-en-US-setting":"31d6cfe0","lang-vi":"31d6cfe0","lang-vi-setting":"31d6cfe0","user":"d63f9ae0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
